import ctl from '@netlify/classnames-template-literals';

export const classes = {
  wrapper: ctl(`
    h-full
    min-w-[250px]
    py-4
    px-3
    rounded-lg
    bg-anti-flash-white
  `),
  list: ctl(`
    flex
    flex-col
    space-y-[2px]
  `),
};
